import { render } from "./notesExamen.vue?vue&type=template&id=4d9f2f2a"
import script from "./notesExamen.vue?vue&type=script&lang=js"
export * from "./notesExamen.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/bulletin/notesExamen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d9f2f2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d9f2f2a', __exports__)) {
    console.log('reload')
    api.reload('4d9f2f2a', __exports__)
  }
  
  module.hot.accept("./notesExamen.vue?vue&type=template&id=4d9f2f2a", () => {
    console.log('re-render')
    api.rerender('4d9f2f2a', render)
  })

}


export default __exports__